module.exports = __webpack_public_path__ + "img/arrow_up_2.d00d397e.svg";